import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-date-time-box";
import "./../../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
class EvaluationQuickFilter {
    ExplorerViewModel: any;
    //observables
    FieldId = ko.observable();
    SelectedField = ko.observable();
    MatchCode = ko.observable();
    FieldTypeKey = ko.observable();
    TextValue = ko.observable();
    DateTimeFromJS = ko.observable();
    DateTimeToJS = ko.observable();
    DateTimeMatchcodeFromJS = ko.observable();
    DateTimeMatchcodeToJS = ko.observable();
    NumberFrom = ko.observable();
    NumberTo = ko.observable();
    BoolValue = ko.observable();
    constructor(explorerViewModel: any) {
        this.ExplorerViewModel = explorerViewModel;
    }
    ;
    //functions
    SetQuickFilterObject() {
        let quickFilterObject = {
            MatchCode: this.MatchCode(),
            FieldTypeKey: this.FieldTypeKey(),
            DateTimeFromJS: this.DateTimeFromJS(),
            DateTimeToJS: this.DateTimeToJS(),
            DateTimeMatchcodeFromJS: this.DateTimeMatchcodeFromJS(),
            DateTimeMatchcodeToJS: this.DateTimeMatchcodeToJS(),
            NumberFrom: this.NumberFrom(),
            NumberTo: this.NumberTo(),
            TextValue: this.TextValue(),
            BoolValue: this.BoolValue()
        };
        this.ExplorerViewModel.QuickFilterJson(JSON.stringify(quickFilterObject));
    }
    ;
    init() {
        //subscribes
        this.SelectedField.subscribe((f: any) => {
            if (f != null) {
                this.MatchCode(f.MatchCode);
                this.FieldTypeKey(f.FieldTypeKey);
            }
            else {
                this.MatchCode(null);
                this.FieldTypeKey(null);
            }
        });
        this.MatchCode.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.FieldTypeKey.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.TextValue.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.DateTimeFromJS.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.DateTimeToJS.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.DateTimeMatchcodeFromJS.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.DateTimeMatchcodeToJS.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.NumberFrom.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.NumberTo.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.BoolValue.subscribe(() => {
            this.SetQuickFilterObject();
        });
        return Bao.get("Checkware/CheckwareExplorer/EvaluationQuickFilter", (template) => {
            this.ExplorerViewModel.QuickFilter(this);
            let templateName = "EvaluationQuickFilter";
            Bao.Templates[templateName] = template;
            this.ExplorerViewModel.QuickFilterTemplateName(templateName);
        });
    }
}
export default EvaluationQuickFilter;